import Hero from "../components/Hero";
import InfoCard from "../components/InfoCard";
import LoadingSpinner from "../components/LoadingSpinner";
import WishlistCardBody from "../components/WishlistCardBody";
import wishlistFallbackImage from "../assets/images/wishlist/wishlist-hero.jpg";
import { useWishlistItems } from "../hooks/useWishlistItems";
import "./WishlistPage.css";
import CTAHero from "../components/CTAHero";
import { useCompanyDetails } from "../hooks/useCompanyDetails";

const WISHLIST_DONATE_EMAIL_SUBJECT = "I'd like to Donate to your wishlist!";

const WishlistPage = () => {
  const { data: items, loading, error } = useWishlistItems();

  const { data: companyDetails } = useCompanyDetails();
  const emailAddress = companyDetails?.companyEmailAddress;

  return (
    <>
      <Hero page="wishlist" titleTwo="Wishlist" />
      <div className="hero-introduction-wrapper wishlist-extra-space">
        <div className="hero-introduction-container">
          <div className="hero-introduction">
            <p>
              <span className="wishlist-marked-text">
                Where Pre-loved items find new purpose.
              </span>{" "}
              <br />
              In this section you'll find what we currently need. If you have
              one of these items lying around, please consider sharing it with
              us so we can give it new life instead.
            </p>
          </div>
          <div className="hero-introduction-circle hero-introduction-circle--wishlist">
            Our farm grows through collective energy, exchange and mutual care.
          </div>
        </div>
      </div>
      <div className="wishlist-page-container">
        <div className="content-container">
          {" "}
          {loading && <LoadingSpinner />}
          {error && (
            <div className="info-card">
              <p>Error: {error}</p>
            </div>
          )}
          {!loading && !error && (!items || items.length === 0) && (
            <div className="wishlist-nothing-published">
              <div className=" info-card">
                <p>No wishlist items published yet.</p>
              </div>
            </div>
          )}
          <div className="wishlist-container">
            {!loading &&
              !error &&
              items?.map((item) => (
                <InfoCard
                  key={item.contentfulId}
                  image={item.imageUrl || wishlistFallbackImage}
                  altText={item.title}
                  color="beige"
                  body={
                    <WishlistCardBody
                      title={item.title}
                      description={item.description}
                    />
                  }
                />
              ))}
          </div>
          <div className="wishlist-donate-container">
            <CTAHero
              link={`mailto:${emailAddress}?subject=${encodeURIComponent(WISHLIST_DONATE_EMAIL_SUBJECT)}`}
              linkText="I want to donate!"
              textColor="mid-green"
              background="green"
              xl={false}
            />
            <p className="wishlist-donate-email">{emailAddress}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default WishlistPage;
